// Toast notification store + helper.
import { createSignal } from 'solid-js';

const [toasts, setToasts] = createSignal([]);
export { toasts };

let nextId = 1;
function push(kind, message, ttl = 4500) {
  const id = nextId++;
  setToasts((arr) => [...arr, { id, kind, message }]);
  setTimeout(() => setToasts((arr) => arr.filter((t) => t.id !== id)), ttl);
}

export const toast = {
  info:    (m) => push('info', m),
  success: (m) => push('success', m),
  warn:    (m) => push('warn', m, 6000),
  error:   (m) => push('error', m, 7000),
  dismiss: (id) => setToasts((arr) => arr.filter((t) => t.id !== id)),
};
